import React from "react"
import { Link, graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import Layout from "../components/layout"
import Seo from "../components/seo"

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.mdx
  const siteTitle = data.site.siteMetadata.title
  const { previous, next } = pageContext

  return (
    <Layout location={location} title={siteTitle}>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={post.frontmatter.imageURL}
      />
      <article>
        <header>
          {/*post.frontmatter.imageURL && (
            <img src={post.frontmatter.imageURL} alt="" />
          )*/}
          <h1 className="article-title">{post.frontmatter.title}</h1>
          <small className="article-metadata">
            {`${post.timeToRead} min read `}&middot;
            {` ${post.frontmatter.date}`}
          </small>
          {post.frontmatter.description && (
            <p className="article-description">
              {post.frontmatter.description}
            </p>
          )}
        </header>
        <hr />
        <MDXRenderer>{post.body}</MDXRenderer>
        <hr
          style={{
            marginBottom: `1rem`,
          }}
        />
        {/*<footer>
          <Bio />
        </footer>*/}
      </article>
      <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlugMdx($id: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(id: { eq: $id }) {
      body
      timeToRead
      frontmatter {
        title
        subtitle
        imageURL
        date(formatString: "MMMM DD, YYYY")
        description
        tags
        editorsNote
      }
    }
  }
`
